import {DashboardMenuContainer} from "../Dashboard/DashboardMenu";
import {Button, Container, Grid} from "@mui/material";
import * as React from "react";
import {ShelterItem} from "./ShelterItem";
import './sheltersStyle.css'
import {collection, getDocs} from "firebase/firestore";
import {useEffect, useState} from "react";
import {Firestore} from "../../../utils/Firebase";
import Loader from "../../common/Loader/Loader";
import Box from "@mui/material/Box";
import {Link} from "react-router-dom";

export default function Shelters() {
    const [sheltersData, setSheltersData] = useState([]);

    useEffect(() => {
        getDocs(collection(Firestore, "shelters"))
            .then(d => {
                const array = [];
                d.forEach(doc => {
                    array.push({...doc.data(), id: doc.id});
                });
                setSheltersData(array);
            })
            .catch(e => {
                console.error(e);
            });
    }, []);


    return (sheltersData.length === 0
            ? DashboardMenuContainer(<Box justifyContent={"center"} alignItems={"center"}><Loader/></Box>)
            : DashboardMenuContainer(
                <Container maxWidth="lg">
                    <h1>Zoznam nocľahárni</h1>
                    <Grid container rowSpacing={7} columnSpacing={{xs: 3, sm: 4, md: 7}}>
                        {
                            sheltersData.map(el => {
                                return (
                                    <Grid item xs={12} sm={6} md={4} key={el.id}>
                                        <ShelterItem image={el.images[0]} name={el.name} address={`${el.city}, ${el.street}`} id={el.id}/>
                                    </Grid>
                                )
                            })
                        }
                    </Grid>

                    <Grid container className={"add-shelter-button"}>
                        <Button variant="contained" component={Link} to={"/shelter/new"}>Pridať nocľaháreň</Button>
                    </Grid>
                </Container>
            )
    );
}
